<template>
  <div>
    <v-bottom-navigation grow app :height="40">
      <v-btn
        :class="[this.$route.name == 'Fooldal' ? 'v-btn--active' : '']"
        to="/fooldal/"
      >
        <span>{{ nyelvesites['mobile_lablec_kezdolap_text'] }}</span>
        <i class="fas fa-home"></i>
      </v-btn>

      <v-btn
        :class="[this.$route.name == 'Elozmenyek' ? 'v-btn--active' : '']"
        to="/elozmenyek/"
      >
        <span>{{ nyelvesites['mobile_lablec_elozmenyek_text'] }}</span>
        <i class="fas fa-clipboard-list"></i>
      </v-btn>

      <v-btn
        :class="[this.$route.name == 'Fontosak' ? 'v-btn--active' : '']"
        to="/fontosak/"
      >
        <span>{{ nyelvesites['mobile_lablec_fontosak_text'] }}</span>
        <i class="fas fa-bookmark"></i>
      </v-btn>

      <v-btn
        :class="[this.$route.name == 'Ertesitesek' ? 'v-btn--active' : '']"
        to="/ertesitesek/"
      >
        <span>{{ nyelvesites['mobile_lablec_ertesitesek_text'] }}</span>
        <div class="relative">
          <i class="fas fa-bell"></i>
        </div>
      </v-btn>

      <v-btn
        :class="[this.$route.name == 'Profil' ? 'v-btn--active' : '']"
        to="/profil/"
      >
        <span>{{ nyelvesites['mobile_lablec_profil_text'] }}</span>
        <i class="fas fa-user"></i>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../../functions/AppFunctions';
import { AppStoreTypes } from '../../store/modules/app';

export default {
  name: 'k-bottom-bar',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  components: {},
};
</script>
